// @flow

// Safe (must never error) wrapper functions for the Matomo event queue

type MatomoCommand = Array<number | string>;

declare var window: {
  _paq?: Array<MatomoCommand>
};

/// Push an event to the Matomo queue, if it's available
export const pushEvent = (command: MatomoCommand) => {
  if (process.env.NODE_ENV === 'development') {
    const [commandName, ...commandArguments] = command;
    console.debug(`[matomo shim] ${commandName}(${commandArguments.map((arg) => JSON.stringify(arg)).join(', ')})`); // eslint-disable-line no-console
  }

  if (window._paq) {
    window._paq.push(command);
  }
};

// Function names and wrapper signatures taken from https://developer.matomo.org/api-reference/tracking-javascript

/// Log a visit to this page
export const trackPageView = (title?: string) => {
  const trackPageViewCommand = ['trackPageView'];

  if (title) {
    trackPageViewCommand.push(title);
  }

  pushEvent(trackPageViewCommand);
};

/// Log an event with an event category and action
export const trackEvent = (category: string, action: string, name?: string, value?: number | string) => {
  const trackEventCommand = ['trackEvent', category, action];

  if (name) {
    trackEventCommand.push(name);

    if (value) {
      trackEventCommand.push(value);
    }
  }

  pushEvent(trackEventCommand);
};

/// Override the page's reported URL
export const setCustomUrl = (url: string) => {
  pushEvent(['setCustomUrl', url]);
};

/// Override the detected Http-Referer
export const setReferrerUrl = (url: string) => {
  pushEvent(['setReferrerUrl', url]);
};
